import PropTypes from 'prop-types';
import React from 'react';

const RELOAD_DEFAULT_VARIANT = { fill: '#FFF' };

const Reload = ({ size = '100%', variant = RELOAD_DEFAULT_VARIANT }) => (
  /* eslint-disable max-len */
  <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 34">
    <path style={variant} d="M33.9,16C33.4,7.1,26.1,0,17,0C7.6,0,0,7.6,0,17s7.6,17,17,17v-6c-6.1,0-11-4.9-11-11S10.9,6,17,6 c5.7,0,10.4,4.4,10.9,10h-6.8l9.9,9.9l9.9-9.9H33.9z" />
  </svg>
  /* eslint-enable max-len */
);

Reload.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  variant: PropTypes.oneOf([
    RELOAD_DEFAULT_VARIANT,
  ]),
};

export default Reload;
